import { ToolbarGroup } from '../ToolbarGroup'
import { TogglePanelToolbarButton } from './TogglePanelToolbarButton'

export function ViewToolbarGroup() {
    return (
        <ToolbarGroup>
            <TogglePanelToolbarButton />
        </ToolbarGroup>
    )
}
